import translations from '../../components/location/ts/pl-PL';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('pl-PL', translations);
